export const candidateName = (candidate) => {
  const user = candidate.user || {};
  return (
    user.full_name ||
    [user.first_name, user.last_name].filter(Boolean).join(' ') ||
    'Unnamed candidate'
  );
};

export const candidateDetails = (candidate) => {
  const user = candidate.user || {};
  const experience = user.current_experience || {};
  return {
    title: experience.title || user.expertise_string || '',
    company: experience.company_name || '',
    location: [experience.area || user.city, user.country?.title || user.country?.name]
      .filter(Boolean)
      .join(', '),
  };
};

export const isBinned = (candidate) => Number(candidate.binned) === 1;

export const filterCandidates = (
  candidates,
  { query = '', stage = '', bin = false, sort = 'name' },
) => {
  const term = query.trim().toLocaleLowerCase();
  return candidates
    .filter((candidate) => {
      if (isBinned(candidate) !== bin) return false;
      if (stage && String(candidate.pipeline_stage_id) !== String(stage)) return false;
      const details = candidateDetails(candidate);
      return (
        !term ||
        [candidateName(candidate), details.title, details.company, details.location]
          .join(' ')
          .toLocaleLowerCase()
          .includes(term)
      );
    })
    .sort((a, b) => {
      const order = candidateName(a).localeCompare(candidateName(b));
      return sort === 'name-desc' ? -order : order;
    });
};
